import { ORIGINAL_USER_LOCAL_STORAGE_KEY } from 'globalConstants';
import AuthService from 'services/auth-service';
import { sessionMonitor } from './sessionMonitor';

export interface ClearLocalSessionOptions {
  /**
   * Only remove this token's session (none when undefined), so a newer sign-in
   * from another tab is kept.
   */
  onlyToken: string | undefined;
}

/**
 * The local half of every sign-out: drop the stored session, drop the
 * impersonation marker once no session remains, and start the monitor over.
 *
 * Without options the stored session is removed whatever it is.
 */
export const clearLocalSession = (options?: ClearLocalSessionOptions): void => {
  if (options) {
    AuthService.removeAuthIfToken(options.onlyToken);
  } else {
    AuthService.removeAuth();
  }
  if (!AuthService.getAuth()) {
    localStorage.removeItem(ORIGINAL_USER_LOCAL_STORAGE_KEY);
  }
  sessionMonitor.reset();
};
